import { client } from './api-client';

export const getParameters = () => client.get(`parameters`);
